  (function() {                                                                                                               'use strict';
                                                                                                                              const CONFIG = {
          PROXY_URL: 'https://threedium-webhook.vercel.app/api/proxy',
          USE_PROXY: true,
          SKIP_PROXY_DOMAINS: ['amazonaws.com', 's3.amazonaws.com', 's3.eu-west-2.amazonaws.com'],
          PROXY_DOMAINS: ['threedium.co.uk', 'threedium.io', 'qe.threedium.io']
      };

      function getProxiedUrl(url) {
          if (!CONFIG.USE_PROXY) return url;
          try {
              const urlObj = new URL(url);
              const shouldSkipProxy = CONFIG.SKIP_PROXY_DOMAINS.some(domain =>
                  urlObj.hostname === domain || urlObj.hostname.endsWith('.' + domain)
              );
              if (shouldSkipProxy) return url;
              const needsProxy = CONFIG.PROXY_DOMAINS.some(domain =>
                  urlObj.hostname === domain || urlObj.hostname.endsWith('.' + domain)
              );
              if (needsProxy) return CONFIG.PROXY_URL + '?url=' + encodeURIComponent(url);
          } catch (e) {
              console.error('[3D] URL parse error:', e);
          }
          return url;
      }

      function isGLBModel(url) {
          const lower = url.toLowerCase();
          if (lower.endsWith('.glb') || lower.endsWith('.gltf')) return true;
          if (lower.includes('generated_model.glb') || lower.includes('pbr_model')) return true;
          if (lower.split('?')[0].endsWith('.glb')) return true;
          return false;
      }

      function createViewer(container) {
          let scene, camera, renderer, controls, currentModel;
          const width = container.clientWidth || 600;
          const height = 720;

          scene = new THREE.Scene();
          scene.background = new THREE.Color(0x080808);
          scene.fog = new THREE.FogExp2(0x080808, 0.03);

          camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1000);
          camera.position.set(0, 2, 5);

          renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false });
          renderer.setClearColor(0x080808, 1);
          renderer.setSize(width, height);
          renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
          renderer.domElement.style.display = 'block';
          renderer.domElement.style.cursor = 'grab';
          container.appendChild(renderer.domElement);

          const placeholder = document.getElementById('viewer-placeholder');
          if (placeholder) placeholder.style.display = 'none';

          // Lighting
          scene.add(new THREE.AmbientLight(0xffffff, 0.6));
          const light1 = new THREE.DirectionalLight(0xffffff, 0.8);
          light1.position.set(5, 10, 5);
          scene.add(light1);
          const light2 = new THREE.DirectionalLight(0xffffff, 0.4);
          light2.position.set(-5, 5, -5);
          scene.add(light2);

          // ═══════════════════════════════════════════
          //  HOLOGRAM GRID (Three.js — proper 3D)
          // ═══════════════════════════════════════════

          var fineGrid = new THREE.GridHelper(120, 50, 0x28c4be, 0x0e3d3b);
          fineGrid.material.opacity = 0.65;
          fineGrid.material.transparent = true;
          fineGrid.material.depthWrite = false;

          var coarseGrid = new THREE.GridHelper(300, 15, 0x185e5a, 0x091f1e);
          coarseGrid.material.opacity = 0.35;
          coarseGrid.material.transparent = true;
          coarseGrid.material.depthWrite = false;

          var hologramGroup = new THREE.Group();
          hologramGroup.add(fineGrid);
          hologramGroup.add(coarseGrid);
          hologramGroup.position.y = 0;
          scene.add(hologramGroup);

          var gridGlow = new THREE.PointLight(0x60D2CC, 0.3, 8);
          gridGlow.position.set(0, 0.2, 0);
          scene.add(gridGlow);

          window.hologramGrid = {
              group: hologramGroup,
              fine: fineGrid,
              coarse: coarseGrid,
              glow: gridGlow,
              fog: scene.fog,
              baseOpacityFine: 0.65,
              baseOpacityCoarse: 0.35,
              baseGlowIntensity: 0.3,
              baseFogDensity: 0.03
          };

          // ═══════════════════════════════════════════

          controls = new THREE.OrbitControls(camera, renderer.domElement);
          controls.enableDamping = true;
          controls.dampingFactor = 0.05;
          controls.enableZoom = true;
          controls.enablePan = true;
          controls.enableRotate = true;
          controls.minDistance = 0.5;
          controls.maxDistance = 15;
          controls.target.set(0, 0, 0);
          controls.update();

          function animate() {
              requestAnimationFrame(animate);
              controls.update();
              renderer.render(scene, camera);
          }
          animate();

         window.addEventListener('resize', function() {
      const w = container.clientWidth;
      const h = 720;
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      renderer.setSize(w, h);
  });

          renderer.domElement.addEventListener('mousedown', function() {
              renderer.domElement.style.cursor = 'grabbing';
          });
          renderer.domElement.addEventListener('mouseup', function() {
              renderer.domElement.style.cursor = 'grab';
          });

          return {
              loadModel: async function(url) {
                  console.log('[3D] Loading:', url);
                  const loadingEl = document.getElementById('loading-indicator');
                  const errorEl = document.getElementById('error-message');
                  const placeholderEl = document.getElementById('viewer-placeholder');

                  if (loadingEl) {
                      loadingEl.style.display = 'block';
                      var lt = document.querySelector('.model-loader__text');
                      if (lt) lt.textContent = 'Loading model...';
                  }
                  if (errorEl) errorEl.style.display = 'none';
                  if (placeholderEl) placeholderEl.style.display = 'none';

                  try {
                      if (currentModel) {
                          scene.remove(currentModel);
                          currentModel = null;
                      }

                      const proxiedUrl = getProxiedUrl(url);

                      if (isGLBModel(url)) {
                          currentModel = await loadGLB(proxiedUrl);
                      } else {
                          throw new Error('Unsupported format. Only GLB models are supported.');
                      }

                      const box = new THREE.Box3().setFromObject(currentModel);
                      const center = box.getCenter(new THREE.Vector3());
                      const size = box.getSize(new THREE.Vector3());
                      currentModel.position.sub(center);
                      const maxDim = Math.max(size.x, size.y, size.z);
                      var targetScale = 1.95 / maxDim;

                      currentModel.scale.setScalar(0.01);
                      scene.add(currentModel);

                      var scaledHalfH = (size.y / 2) * targetScale;
                      hologramGroup.position.y = -scaledHalfH - 0.01;
                      gridGlow.position.y = -scaledHalfH + 0.3;

                      const scaledH = size.y * targetScale;
controls.target.set(0, scaledH * 0.0, 0);
camera.position.set(0, scaledH * 0.4, scaledH * 2.2);
controls.update();
// initial zoom-out
const zoomOut = 1.45; // 1.25 malo, 1.45 srednje, 1.7 dosta
const v = new THREE.Vector3().subVectors(camera.position, controls.target);
camera.position.copy(controls.target).add(v.multiplyScalar(zoomOut));
controls.update();

                      if (loadingEl) loadingEl.style.display = 'none';

                      var startTime = Date.now();
                      var duration = 600;
                      function animateEntrance() {
                          var elapsed = Date.now() - startTime;
                          var t = Math.min(elapsed / duration, 1);
                          var ease = 1 - Math.pow(1 - t, 3);
                          currentModel.scale.setScalar(targetScale * ease);
                          if (t < 1) requestAnimationFrame(animateEntrance);
                      }
                      animateEntrance();

                      console.log('[3D] Model loaded successfully!');
                      return true;
                  } catch (error) {
                      console.error('[3D] Error:', error);
                      if (loadingEl) loadingEl.style.display = 'none';
                      if (errorEl) {
                          errorEl.textContent = 'Error: ' + error.message;
                          errorEl.style.display = 'block';
                      }
                      return false;
                  }
              }
          };
      }

      function loadGLB(url) {
          return new Promise((resolve, reject) => {
              const loader = new THREE.GLTFLoader();
              loader.load(
                  url,
                  (gltf) => {
                      console.log('[GLB] Loaded successfully!');
                      resolve(gltf.scene);
                  },
                  (progress) => {
                      if (progress.total > 0) {
                          const percent = Math.round((progress.loaded / progress.total) * 100);
                          var loaderText = document.querySelector('.model-loader__text');
                          if (loaderText) loaderText.textContent = 'Loading model... ' + percent + '%';
                      }
                  },
                  (error) => {
                      console.error('[GLB] Load error:', error);
                      let errorMsg = 'Failed to load GLB model';
                      if (error && error.target) {
                          if (error.target.status === 403) {
                              errorMsg = 'Access denied (403). The model link may be expired.';
                          } else if (error.target.status === 404) {
                              errorMsg = 'Model not found (404).';
                          } else if (error.target.status === 0) {
                              errorMsg = 'CORS error. Cannot access model.';
                          }
                      }
                      reject(new Error(errorMsg));
                  }
              );
          });
      }

      function init() {
          console.log('[3D] Initializing...');
          if (typeof THREE === 'undefined' || typeof THREE.OrbitControls === 'undefined' || typeof THREE.GLTFLoader ===
  'undefined') {
              console.error('[3D] Required libraries not loaded');
              return;
          }

          const urlParams = new URLSearchParams(window.location.search);
          const modelUrl = urlParams.get('3d_model');
          const input = document.getElementById('model-link-input');

          if (input && modelUrl) {
              input.value = modelUrl;
              input.dispatchEvent(new Event('input', { bubbles: true }));
          }

          const container = document.getElementById('product-3d-viewer');
          if (!container) return;

          const viewer = createViewer(container);
          window.viewer3D = viewer;

          if (modelUrl) viewer.loadModel(modelUrl);

          if (input) {
              input.addEventListener('change', function() {
                  const url = input.value.trim();
                  if (url) viewer.loadModel(url);
              });
              input.addEventListener('keypress', function(e) {
                  if (e.key === 'Enter') {
                      e.preventDefault();
                      const url = input.value.trim();
                      if (url) viewer.loadModel(url);
                  }
              });
          }
      }

      if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
      } else {
          init();
      }
  })();




